// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ScrollTop_wrap__1TmK1","svg":"ScrollTop_svg__29Rx0","svg_second":"ScrollTop_svg_second__cxOth","wrap_blue":"ScrollTop_wrap_blue__blBiH"};